export default (firstname, lastname) => {
  const fullName = firstname ? lastname ? firstname.concat(' ', lastname) : firstname : lastname;
  const initials = fullName.split(/[- ]+/).map((item) => item[0]).join('');
  return initials.toUpperCase();
};
